import React from 'react';

/**
 * Displays bid results for a cycle in a compact format.
 * Shows all participants' bids with winner highlighted.
 *
 * @param {Object} bidResults - The bid results object with bids array
 * @param {boolean} compact - If true, uses more compact inline styling for message display
 */
export function BidResults({ bidResults, compact = false }) {
  if (!bidResults || !bidResults.bids || bidResults.bids.length === 0) {
    return null;
  }

  const { bids } = bidResults;

  return (
    <div className={`bid-results ${compact ? 'bid-results-compact' : ''}`}>
      <div className="bid-results-header">
        Bids
      </div>
      <div className="bid-results-list">
        {bids.map((bid, index) => (
          <div
            key={bid.participant_id || index}
            className={`bid-result-item ${bid.is_winner ? 'winner' : ''} ${!bid.success ? 'failed' : ''}`}
          >
            <span className="bid-participant-name">
              {bid.participant_name}
              {bid.is_winner && <span className="winner-badge">WIN</span>}
            </span>
            {bid.success ? (
              <span className="bid-values">
                <span className="raw-bid">{bid.raw_priority}</span>
                <span className="arrow">→</span>
                <span className="final-bid">{Math.round(bid.final_priority)}</span>
              </span>
            ) : (
              <span className="bid-error">FAILED</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
